export enum CautionaryFoodType {
    None = 0,
    NonCaffeinatedSupplementedFood = 1,
    CaffeinatedSupplementedFood = 2,
  }